import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAccount } from "../redux/actions/AccountPageActions";
import styles from './accountStyling.module.css'
const AccountsDropDown=()=>{
    const {data} = useSelector((state) => state.accountsData);
    const dispatch=useDispatch();
    const accounts=data ? Object.keys(data) : null;
    accounts && accounts.unshift("Select Account");
    const selectedAccount=(event)=>{
        if(event.target.value.toLowerCase()!=="select account"){
            dispatch(setAccount(event.target.value));
        }
        else{
            dispatch(setAccount(null));
        }
    }
    return(
        accounts? <div className={styles.accountsDropDown}>
            <form className={styles.accountsListDiv}>
                <label htmlFor={styles.selectAccounts} className={styles.account}>List of Accounts</label>
                <select name="accounts" id={styles.selectAccounts} onChange={selectedAccount}>
                    {accounts.map((accountOption)=>{
                        return <option key={accountOption} value={accountOption}>{accountOption}</option>
                    })}
                </select>
            </form>
        </div> : <h1>Loading</h1>
    )
}

export default AccountsDropDown;